import { useSearchParams } from '@remix-run/react'

export function useStructureTypeParams() {
	const [searchParams, setSearchParams] = useSearchParams()
	const selectedStructureType = searchParams.getAll('structure-type')
	function toggleStructureTypeParam(structureTypeId: string) {
		if (selectedStructureType.includes(structureTypeId)) {
			setSearchParams(searchParams => {
				searchParams.delete('structure-type', structureTypeId)
				return searchParams
			})
		} else {
			setSearchParams(searchParams => {
				searchParams.append('structure-type', structureTypeId)
				return searchParams
			})
		}
	}
	return { selectedStructureType, toggleStructureTypeParam }
}
